import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { Location } from 'history';

import {
  userSelector,
  isAdminSelector,
  isAuthenticatedSelector,
} from 'redux/selectors/authenticationSelectors';
import { useAppSelector } from 'hooks/useAppSelector';

type Props = {
  [propName: string]: any;
};

// A wrapper for <Route> that redirects to the home
// page if you've already completed the profile setup.
export default function OnboardingRoute(props: Props) {
  const { roles, ...rest } = props;
  const location = useLocation();
  const isAuthenticated = useAppSelector(isAuthenticatedSelector);
  const user = useAppSelector(userSelector);
  const isAdminRole = useAppSelector(isAdminSelector);
  const shouldFillInitialProfileSetup =
    !user?.isProfileComplete && !isAdminRole;

  const renderContentForAuthenticatedUser = () => {
    if (!shouldFillInitialProfileSetup) {
      return <Navigate to="/" />;
    }

    return <Outlet {...rest} />;
  };

  const renderContent = (location: Location) => {
    if (isAuthenticated) {
      return renderContentForAuthenticatedUser();
    }

    return <Navigate to="/login" state={{ from: location }} />;
  };

  return renderContent(location);
}
